module.exports = __webpack_public_path__ + "img/edit-form-img.c0c40e5e.svg";